import React from 'react';
import backgroundVideo from '../../assets/Video/2835995-uhd_3840_2160_24fps.mp4';

export const HeroAbout = () => {
  return (
    <section className="HeroSection bg-white overflow-hidden w-full mx-auto flex items-center justify-center pt-[113px] max-w-[1920px] xl:max-w-[2560px] 2xl:max-w-[3840px]">
      {/* Background Video and Text Content Container */}
      <div className="relative w-full h-[700px] sm:h-[850px] lg:h-[992px] 2xl:h-[1100px] flex items-center justify-center">
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={backgroundVideo} type="video/mp4" loading="lazy" />
          Your browser does not support the video tag.
        </video>

        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(245deg, rgba(0, 0, 0, 0) 23.99%, #000 99.36%)',
            mixBlendMode: 'multiply',
          }}
        />

        {/* Text Content */}
        <div className="relative z-20 flex flex-col items-center text-center gap-6 px-4 sm:px-8 lg:px-20 xl:px-32 2xl:px-48 max-w-[885px]">
          {/* Heading */}
          <h1 className="text-white text-[36px] sm:text-[48px] md:text-[60px] lg:text-[72px] 2xl:text-[86px] font-bold leading-tight">
            <span className="text-white">Building Dreams</span>{' '}
            <span className="text-[#5bc0fe]">Designing</span>{' '}
            <span className="text-white">Futures</span>
          </h1>

          {/* Optional Description */}
          {/* <p className="text-white text-[20px] md:text-[22px] font-normal leading-[150%]">
            At our core, we are passionate designers and visionary thinkers committed to delivering outstanding architectural solutions. Our team thrives on creativity, collaboration, and craftsmanship to bring innovative spaces to life.
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default HeroAbout;
